import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";

import { BasicForm } from "@components/shared";
import timezones from "@lib/timezones";

export default function ContestPickupForm({
  contactName = "",
  contactNumber = "",
  contactEmail = "",
  id,
  onSuccess,
  pickupDate = "",
  pickupTime = "",
  pickupTimezone = "",
}) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  function onSubmit(formData) {
    setLoading(true);

    const formatted = {
      ...formData,
    };

    return onUpdate(formatted);
  }

  function onUpdate(formData) {
    const req = { ...formData };

    axios
      .put(`/contests/${id}/contest-pickup/`, req)
      .then(() => {
        toast.success(t("common:updated") + "!");
        setLoading(false);
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "contact_name",
      label: t("mixer:contest:contest_pickup_name"),
      initialValue: contactName,
      required: true,
      schema: () =>
        Yup.string()
          .max(100, t("validation:too_long"))
          .required(t("validation:required")),
    },
    {
      name: "contact_number",
      label: t("mixer:contest:contest_pickup_number"),
      mask: {
        pattern: "(999) 999-9999",
        placeholder: "(XXX) XXX-XXXX",
      },
      initialValue: contactNumber,
      required: true,
      schema: () =>
        Yup.string()
          .max(50, t("validation:too_long"))
          .required(t("validation:required")),
    },
    {
      name: "contact_email",
      label: t("mixer:contest:contest_pickup_email"),
      initialValue: contactEmail,
      required: true,
      schema: () =>
        Yup.string()
          .max(50, t("validation:too_long"))
          .email(t("validation:email_invalid"))
          .required(t("validation:required")),
    },
    {
      name: "pickup_date",
      initialValue: pickupDate,
      label: t("mixer:contest:contest_pickup_date"),
      required: true,
      schema: () => Yup.string().required(t("validation:required")),
      datepicker: {},
    },
    {
      name: "pickup_time",
      initialValue: pickupTime,
      required: true,
      schema: () =>
        Yup.string(t("validation:required"))
          .nullable()
          .required(t("validation:required")),
      label: t("mixer:contest:contest_pickup_time"),
      timepicker: {},
    },
    {
      name: "pickup_timezone",
      initialValue: pickupTimezone,
      required: true,
      select: true,
      schema: () =>
        Yup.string(t("validation:required"))
          .nullable()
          .required(t("validation:required")),
      label: t("mixer:contest:contest_pickup_timezone"),
      options: timezones,
    },
  ];

  return (
    <BasicForm
      fields={fields}
      loading={loading}
      onSubmit={(d) => onSubmit(d)}
      buttonProps={{
        fullWidth: false,
      }}
    />
  );
}
